import Svg, { type SvgProps } from '../../Svg';

/**
 * Remove Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=1010%3A23781&mode=dev)
 * */

const AddIcon = (props: SvgProps) => (
  <Svg width={12} height={12} {...props}>
    <g
      clipPath="url(#clip0_565_9011)"
      className="stroke-current"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 1v10M1 6h10" />
    </g>
    <defs>
      <clipPath id="clip0_565_9011">
        <path fill="fill-current" d="M0 0H12V12H0z" />
      </clipPath>
    </defs>
  </Svg>
);

export default AddIcon;
